import { render, staticRenderFns } from "./CorpForm.vue?vue&type=template&id=5f707a82&scoped=true"
import script from "./CorpForm.vue?vue&type=script&lang=ts"
export * from "./CorpForm.vue?vue&type=script&lang=ts"
import style0 from "./CorpForm.vue?vue&type=style&index=0&id=5f707a82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f707a82",
  null
  
)

export default component.exports